import React, { useState, useEffect } from "react";
import api from "../../api";

export default function PracticeSetQuestionsModal({
  show,
  onClose,
  practiceSet,
}) {
  const [type, setType] = useState("normal");
  const [questions, setQuestions] = useState([]);
  const [selectedNormal, setSelectedNormal] = useState([]);
  const [selectedReasoning, setSelectedReasoning] = useState([]);
  const [loading, setLoading] = useState(false);

  const getImageUrl = (path) => {
    if (!path) return null;

    if (path.startsWith("http")) return path;

    const apiBase = api.defaults.baseURL; 
    const root = apiBase.replace(/\/api\/?$/, "");

    return `${root}${path.startsWith("/") ? path : "/" + path}`;
  };



  useEffect(() => {
    if (show && practiceSet?.id) {
      loadQuestions();
    }
  }, [show, practiceSet, type]);

  const loadQuestions = async () => {
    try {
      setLoading(true);

      const url =
        type === "reasoning"
          ? `/admin/reasoning/practice_set/${practiceSet.id}/candidate_reasoning_questions`
          : `/admin/practice_set/${practiceSet.id}/candidate_questions`;

      const res = await api.get(url);
      setQuestions(res.data.questions || []);
    } catch (err) {
      alert("❌ Questions load failed");
    } finally {
      setLoading(false);
    }
  };

  const toggle = (id) => {
    if (type === "normal") {
      setSelectedNormal((prev) =>
        prev.includes(id)
          ? prev.filter((x) => x !== id)
          : [...prev, id]
      );
    } else {
      setSelectedReasoning((prev) =>
        prev.includes(id)
          ? prev.filter((x) => x !== id)
          : [...prev, id]
      );
    }
  };

  const save = async () => {
    const totalSelected =
      selectedNormal.length + selectedReasoning.length;

    if (totalSelected !== practiceSet.num_questions) {
      alert(
        `Exactly ${practiceSet.num_questions} questions required (Selected: ${totalSelected})`
      );
      return;
    }

    try {
      if (selectedNormal.length > 0) {
        await api.post(
          `/admin/practice_set/${practiceSet.id}/assign_questions`,
          { question_ids: selectedNormal }
        );
      }

      if (selectedReasoning.length > 0) {
        await api.post(
          `/admin/reasoning/practice_set/${practiceSet.id}/assign_reasoning`,
          { reasoning_question_ids: selectedReasoning }
        );
      }

      alert("✅ Practice Set saved successfully!");
      onClose();
    } catch {
      alert("❌ Save failed");
    }
  };

  if (!show) return null;

  const totalSelected =
    selectedNormal.length + selectedReasoning.length;

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={header}>
          <h2>Select Questions</h2>

          <div style={tabs}>
            <button
              style={tab(type === "normal")}
              onClick={() => setType("normal")}
            >
              Normal
            </button>
            <button
              style={tab(type === "reasoning")}
              onClick={() => setType("reasoning")}
            >
              Reasoning
            </button>
          </div>

          <p>Selected: {totalSelected}</p>
        </div>

        <div style={listContainer}>
          {loading ? (
            <p>Loading...</p>
          ) : questions.length === 0 ? (
            <p style={{ color: "red" }}>No questions found</p>
          ) : (
            questions.map((q) => {
              const isChecked =
                type === "normal"
                  ? selectedNormal.includes(q.id)
                  : selectedReasoning.includes(q.id);

              return (
                <div key={q.id} style={row(isChecked)}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => toggle(q.id)}
                  />

                  <div style={{ flex: 1 }}>
                    {type === "normal" && (
                      <p style={{ fontWeight: 500 }}>{q.text}</p>
                    )}

                    {type === "reasoning" && (
                      <img
                        src={getImageUrl(q.question_image)}
                        alt="reasoning"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 150,
                          objectFit: "contain",
                          marginBottom: 10,
                          border: "1px solid #ddd",
                          borderRadius: 6,
                        }}
                      />
                    )}

                    <div style={{ fontSize: 14 }}>
                      A) {q.option_a} | B) {q.option_b} | C) {q.option_c} | D){" "}
                      {q.option_d}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div style={footer}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modal = {
  background: "#fff",
  width: "85%",
  height: "85vh",
  display: "flex",
  flexDirection: "column",
  borderRadius: 10,
  overflow: "hidden",
};

const header = {
  padding: 20,
  borderBottom: "1px solid #eee",
};

const listContainer = {
  flex: 1,
  overflowY: "auto",
  padding: 20,
};

const footer = {
  padding: 15,
  borderTop: "1px solid #eee",
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
};

const tabs = { display: "flex", gap: 10, marginBottom: 10 };

const tab = (active) => ({
  padding: "6px 14px",
  borderRadius: 20,
  border: "none",
  cursor: "pointer",
  background: active ? "#2563eb" : "#e5e7eb",
  color: active ? "#fff" : "#111",
});

const row = (active) => ({
  display: "flex",
  gap: 12,
  padding: 12,
  marginBottom: 10,
  borderRadius: 8,
  background: active ? "#dbeafe" : "#f9fafb",
});
